import React from 'react';
import SiteLayout from '../components/SiteLayout';
import PageHero from '../components/PageHero';
import CtaBand from '../components/CtaBand';
import StructuralSlider from '../structural/StructuralSlider';
import { useStructuralCards, useCtaStructural, usePageStructural } from '../data';

// §7.2 — Hero → card slider → CTA band.
export default function StructuralPage() {
  const page = usePageStructural();
  return (
    <SiteLayout navVariant="page">
      <PageHero accent={page.titleAccent} white={page.titleWhite} accentFirst lead={page.lead} variant="structural" />
      <StructuralSlider cards={useStructuralCards()} />
      <CtaBand cta={useCtaStructural()} variant="structural" />
    </SiteLayout>
  );
}
